function reducer(state = [], action) {
    switch (action.type) {
        case 'FAMILY/REGISTRATION/SET':
            return action.users;
        default:
            return state;
    }
}

export default reducer;
